import React, { useEffect, useMemo, useState } from "react";
import DataTable, { SortOrder } from "react-data-table-component";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import moment from "moment";
import { use } from "react";
import Popup from "../common/popup";
import discountIcon from "../assets/images/discount-icon.png";
import { useTranslation } from "react-i18next";

export const PromoOrders = ({}) => {
  const { t } = useTranslation();

  const priceFormat = (price) => {
    return price.toLocaleString("en-US", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    });
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px", // override the cell padding for head cells
      },
    },
    cells: {
      style: {
        padding: "8px", // override the cell padding for data cells
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  const getFiscalMonthNumber = () => {
    const currentMonth = new Date().getMonth(); // 0 = Jan, 1 = Feb, ..., 3 = Apr
    // Fiscal month index: starts from Sep (8), wraps around
    const fiscalIndex = (currentMonth - 8 + 12) % 12;
    const fiscalMonthNumber = ((fiscalIndex + 8) % 12) + 1;
    return fiscalMonthNumber.toString(); // For useState
  };

  var currentTime = new Date();
  var currentyear = currentTime.getFullYear();
  var currentMonth = currentTime.getUTCMonth() + 1;
  const [filter, setFilter] = useState(0);
  const [filtertext, setFilterText] = useState("");
  const [temporders, setTempOrders] = useState([]);
  const searchInputRef = React.createRef();
  const [promoOrders, setPromoOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [sector, setSector] = useState("All");
  const [sectorList, setSectorList] = useState([]);
  const [filterType, setFilterType] = useState("order"); // default
  const getCurrentFiscalYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    // Fiscal year starts in September
    const startYear = month >= 9 ? year : year - 1;
    const endYear = startYear + 1;
    return `${startYear}-${endYear}`;
  };
  const [period, setPeriod] = useState(getCurrentFiscalYear());
  const [offerRange, setOfferRange] = useState("all"); // Default to 250
  const [searchInput, setSearchInput] = useState("");
  const [allCustomers, setAllCustomers] = useState([]); // Store full unfiltered records
  const [months, setMonths] = useState("9");
  const [quarter, setQuarter] = useState("");
  const [popupView1, setPopupView1] = useState("");
  const [alertPopup, setAlertPopup] = useState(false);
  const [showOrderDetail, setShowOrderDetail] = useState(false);
  const [orderDetail, setOrderDetail] = useState({});
  const [analysisType, setAnalysisType] = useState("cart");
  const [mainDepot, setMainDepot] = useState("");
  const [subDepotList, setSubDepotList] = useState([]);
  const [mainDepotList, setMainDepotList] = useState([]);
  const [depots, setDepots] = useState([]);
  const [subDepot, setSubDepot] = useState("");
  const [orderDetailPopup, setOrderDetailPopup] = useState({
    headMoreTxt: "",
    closeButton: (
      <>
        <div className="order-top">
          <div className="head">
            <h4>
              {t("order_details_txt")} - {orderDetail?.OrderNumber}
            </h4>
          </div>
          <span onClick={(e) => closeOrderDetail()} className="close"></span>
        </div>
      </>
    ),
    bodyMoreTxt: <div className="loading-buffer"></div>,
  });

  const fetchSectors = async () => {
    try {
      let URL = BaseUrl + "admin/product/masterentries/sectors";
      const response = await http.get(URL);
      const data = response.data.data;
      setSectorList(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchSectors();
  }, []);

  const MonthNames = [
    t("months.sep"),
    t("months.oct"),
    t("months.nov"),
    t("months.dec"),
    t("months.jan"),
    t("months.feb"),
    t("months.mar"),
    t("months.apr"),
    t("months.may"),
    t("months.jun"),
    t("months.jul"),
    t("months.aug"),
  ];
  const currentFiscalMonth = new Date().getMonth(); // 0-indexed: Jan = 0, Apr = 3, Sep = 8

  const quarterNames = {
    1: t("quarter_sep_nov"),
    2: t("quarter_dec_feb"),
    3: t("quarter_mar_may"),
    4: t("quarter_jun_aug"),
  };

  const columns = useMemo(() => {
    if (analysisType === "sector") {
      return [
        {
          name: t("account_code_txt"),
          selector: (row) => row.accountCode,
          sortable: false,
        },
        {
          name: t("account_name_txt"),
          selector: (row) => row.accountName,
          sortable: false,
        },
        {
          name: t("order_id_txt"),
          selector: (row) => row.OrderNumber,
          cell: (row) => (
            <div style={{ display: "flex" }}>
              <a
                className="button"
                data-title={t("view_order_details_txt")}
                onClick={() => getOrderDetails(row)}
              >
                {row.OrderNumber}
              </a>
            </div>
          ),
          sortable: true,
        },
        {
          name:
            filterType === "order"
              ? t("ordered_date_txt")
              : t("delivery_date_txt"),
          selector: (row) =>
            filterType === "order"
              ? moment(row.createdAt).format("DD/MM/YYYY")
              : row.DateRequired,
          sortable: false,
        },
        {
          name: t("cus_sector_txt"),
          selector: (row) => row.client?.Sectors,
          sortable: false,
          style: {
            justifyContent: "flex-start", // LEFT align (fix issue)
            textAlign: "left",
          },
        },
        {
          name: t("order_amount_txt"),
          selector: (row) =>
            priceFormat(parseFloat(row.OrderTotalWithVat || 0)),
          sortable: false,
        },
        {
          name: t("main_local_depot_txt"),
          selector: (row) =>
            row.client?.mainDepot && row.client?.subDepot
              ? `${row.client.mainDepot} / ${row.client.subDepot}`
              : "-",
          sortable: false,
        },
      ];
    } else {
      return [
        {
          name: t("account_code_txt"),
          selector: (row) => row.accountCode,
          sortable: false,
        },
        {
          name: t("account_name_txt"),
          selector: (row) => row.accountName,
          sortable: false,
        },
        {
          name: t("order_id_txt"),
          selector: (row) => row.OrderNumber,
          cell: (row) => (
            <div style={{ display: "flex" }}>
              <a
                className="button"
                data-title={t("view_order_details_txt")}
                onClick={() => getOrderDetails(row)}
              >
                {row.OrderNumber}
              </a>
            </div>
          ),
          sortable: true,
        },
        {
          name:
            filterType === "order"
              ? t("ordered_date_txt")
              : t("delivery_date_txt"),
          selector: (row) =>
            filterType === "order"
              ? moment(row.createdAt).format("DD/MM/YYYY")
              : row.DateRequired,
          sortable: false,
        },
        {
          name: t("spend_before_promo_txt"),
          selector: (row) => priceFormat(parseFloat(row.offerConvertFrom)),
          sortable: false,
        },
        {
          name: t("spend_after_promo_txt"),
          selector: (row) => priceFormat(parseFloat(row.OrderTotalWithVat)),
          sortable: false,
        },
        {
          name: t("difference_in_spend_txt"),
          selector: (row) =>
            priceFormat(
              parseFloat(row.OrderTotalWithVat) -
                parseFloat(row.offerConvertFrom),
            ),
          sortable: false,
        },
      ];
    }
  }, [analysisType, filterType]);

  const changeMainDepotHandler = (e) => {
    setSubDepot("");
    setMainDepot(e.target.value);
  };

  const changeSubDepotHandler = (e) => {
    setSubDepot(e.target.value);
  };

  useEffect(() => {
    let URL = BaseUrl + `admin/getdepots`;
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data;
        const uniqueDepots = Array.from(
          new Set(responseData.map((item) => item.mainDepot)),
        ).map((mainDepot) =>
          responseData.find((item) => item.mainDepot === mainDepot),
        );
        setSubDepotList(responseData);
        setDepots(responseData);
        setMainDepotList(uniqueDepots);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (mainDepot === "") {
      setSubDepotList(depots);
    } else {
      setSubDepotList(depots.filter((item) => item.mainDepot === mainDepot));
    }
  }, [mainDepot, mainDepotList]);

  const getFiscalYearRange = (periodStr) => {
    const [start, end] = periodStr.split("-");
    const startDate = new Date(parseInt(start), 8, 1); // Sept 1
    const endDate = new Date(parseInt(end), 7, 31, 23, 59, 59, 999); // Aug 31
    return { startDate, endDate };
  };

  const getQuarterDateRange = (fiscalYearStartYear, quarter) => {
    const fiscalStartMonth = 8; // September
    const quarterIndex = parseInt(quarter) - 1;
    const startMonth = (fiscalStartMonth + quarterIndex * 3) % 12;
    const startYear =
      fiscalYearStartYear +
      Math.floor((fiscalStartMonth + quarterIndex * 3) / 12);
    const start = new Date(startYear, startMonth, 1);
    // Adjust end month/year correctly even when wrapping around year-end
    const tempEndMonth = startMonth + 2;
    const endMonth = tempEndMonth % 12;
    const endYear = startYear + Math.floor(tempEndMonth / 12);
    const end = new Date(endYear, endMonth + 1, 0, 23, 59, 59, 999);
    return { start, end };
  };

  const getCurrentFiscalQuarter = () => {
    const month = new Date().getMonth() + 1; // 1–12
    if (month >= 9 && month <= 11) return 1; // Sep–Nov
    if (month === 12 || month <= 2) return 2; // Dec–Feb
    if (month >= 3 && month <= 5) return 3; // Mar–May
    return 4; // Jun–Aug
  };

  const getAvailableQuarters = (selectedFiscalYear) => {
    const currentFiscalYear = getCurrentFiscalYear();
    const currentQuarter = getCurrentFiscalQuarter();
    return Object.entries(quarterNames)
      .filter(([quarterNumber]) => {
        if (selectedFiscalYear === currentFiscalYear) {
          return Number(quarterNumber) <= currentQuarter;
        }
        return true; // show all for past years
      })
      .map(([quarterNumber, label]) => (
        <option key={quarterNumber} value={quarterNumber}>
          {label}
        </option>
      ));
  };

  useEffect(() => {
    const now = new Date();
    const month = now.getMonth() + 1;
    const fiscalQuarterMap = {
      9: 1,
      10: 1,
      11: 1,
      12: 2,
      1: 2,
      2: 2,
      3: 3,
      4: 3,
      5: 3,
      6: 4,
      7: 4,
      8: 4,
    };
    const currentFiscalQuarter = fiscalQuarterMap[month];
    setQuarter(currentFiscalQuarter);
  }, []);

  useEffect(() => {
    if (filter === "custom" && (!fromDate || !toDate)) {
      // Don't make the API call if dates are missing for the "custom" filter
      return;
    }
    setIsLoading(true);
    let payload = {};
    if (filter === "custom") {
      payload = {
        filter: filter,
        datefrom: format(new Date(fromDate), "yyyy-MM-dd"),
        dateto: format(new Date(toDate), "yyyy-MM-dd"),
        sector: sector,
        mainDepot: mainDepot,
        subDepot: subDepot,
        filterType: filterType,
      };
      setShowDatePicker(false);
    } else if (filter === "monthly") {
      payload = {
        filter: filter,
        datefrom: "",
        dateto: "",
        period: period,
        month: months,
        sector: sector,
        mainDepot: mainDepot,
        subDepot: subDepot,
        filterType: filterType,
      };
    } else if (["weekly", "quarterly", "FYdata"].includes(filter)) {
      payload = {
        filter: filter,
        datefrom: "",
        dateto: "",
        quarter: filter === "quarterly" ? quarter : "",
        period: period,
        sector: sector,
        mainDepot: mainDepot,
        subDepot: subDepot,
        filterType: filterType,
      };
    } else {
      payload = {
        filter: parseInt(filter),
        datefrom: "",
        dateto: "",
        sector: sector,
        mainDepot: mainDepot,
        subDepot: subDepot,
        filterType: filterType,
      };
    }
    let URL2 =
      analysisType === "sector"
        ? BaseUrl + "admin/getSectorPromoOrders"
        : BaseUrl + "admin/getpromoorders";
    http
      .post(URL2, payload)
      .then((response) => {
        setIsLoading(false);
        let data = response.data.data;
        if (analysisType === "cart") {
          data = data.filter(
            (item) =>
              parseFloat(item.offerConvertFrom) > 0 &&
              parseFloat(item.OrderTotalWithVat) -
                parseFloat(item.offerConvertFrom) >
                0,
          );
        }
        // sorting for BOTH cart & sector
        data = data.sort((a, b) => {
          const dateA =
            filterType === "order"
              ? new Date(a.createdAt)
              : moment(a.DateRequired, "DD/MM/YYYY").toDate();
          const dateB =
            filterType === "order"
              ? new Date(b.createdAt)
              : moment(b.DateRequired, "DD/MM/YYYY").toDate();
          return dateB - dateA;
        });
        console.log("Fetched Promo Orders:", data);
        setPromoOrders(data);
        setTempOrders(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [filter, fromDate, toDate, months, quarter, period, analysisType, sector, mainDepot, subDepot, filterType]);

  useEffect(() => {
    setSearchInput("");
    setSector("All");
    setMainDepot("");
    setSubDepot("");
  }, [analysisType]);

  const totalBeforeSpend = useMemo(() => {
    return promoOrders.reduce((total, order) => {
      return total + parseFloat(order.offerConvertFrom || 0);
    }, 0);
  }, [promoOrders]);

  const totalAfterSpend = useMemo(() => {
    return promoOrders.reduce((total, order) => {
      return total + parseFloat(order.OrderTotalWithVat || 0);
    }, 0);
  }, [promoOrders]);

  const totalDifference = useMemo(() => {
    return promoOrders.reduce((total, order) => {
      return (
        total +
        (parseFloat(order.OrderTotalWithVat || 0) -
          parseFloat(order.offerConvertFrom || 0))
      );
    }, 0);
  }, [promoOrders]);

  const closeOrderDetail = (e) => {
    setOrderDetail({});
    setShowOrderDetail(false);
  };

  const getOrderDetails = (stripelog) => {
    setOrderDetailPopup({
      headMoreTxt: "",
      closeButton: (
        <>
          <div className="order-top">
            <div className="head">
              <h4>
                {t("order_details_txt")} - {stripelog.OrderNumber}
              </h4>
            </div>
            <span onClick={(e) => closeOrderDetail()} className="close"></span>
          </div>
        </>
      ),
      bodyMoreTxt: <div className="loading-buffer"></div>,
    });
    setOrderDetail({ orderNumber: stripelog.OrderNumber });
    setShowOrderDetail(true);
    var numberOfAjaxCAllPending = 0;
    var timeInterval = 20000;
    var current = this;
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    var URL = BaseUrl + "admin/getorderdetails/" + stripelog.OrderNumber;
    http
      .get(URL)
      .then((response) => {
        numberOfAjaxCAllPending++;
        let responseData = [];
        responseData = response.data.data[0];
        setIsLoading(false);
        viewOrderlogDetails(responseData);
        setAlertPopup(false);
      })
      .catch((err) => {
        console.log(err);
        setAlertPopup(false);
        setIsLoading(false);
      });
  };

  const vatAmountCalcuation = (order) => {
    var totalAmount = 0;
    order.items.map((item, value) => {
      if (item.TaxCode !== "" && item.TaxCode === "T1") {
        totalAmount += item.LinePrice;
      }
    });
    return totalAmount;
  };

  const viewOrderlogDetails = (order) => {
    var ordertotal = 0;
    var subTotal = 0;
    setAlertPopup(false);
    order.items.map((item) => {
      ordertotal += item.LinePrice;
    });
    order.items.map((item) => {
      subTotal += item.UnitPrice * item.QuantityOrdered;
    });
    var vatTotalAmount = vatAmountCalcuation(order);
    var vatAmount = 0;
    if (vatTotalAmount > 0) {
      vatAmount = (vatTotalAmount / 100) * 20;
      ordertotal = ordertotal + vatAmount;
    }
    if (order.accountEmail !== undefined) {
      setOrderDetail((prev) => ({
        ...prev,
        oaccountName: order.accountName,
        oaccountEmail: order.accountEmail,
        oaccountAddress: order.accountAddress,
      }));
      createPopup(order, subTotal, ordertotal, vatAmount, vatTotalAmount);
    } else {
      var loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      let URL = BaseUrl + "admin/account/" + order.accountCode;
      http
        .get(URL)
        .then((response) => {
          let responseData = [];
          responseData = response.data.data;
          let addressFields = [
            responseData.accountAddress1,
            responseData.accountAddress2,
            responseData.accountAddress3,
            responseData.accountAddress4,
            responseData.accountAddress5,
          ];
          setOrderDetail((prev) => ({
            ...prev,
            oaccountName: responseData.accountName,
            oaccountEmail: responseData.accountEmail,
            oaccountAddress: addressFields
              .filter((field) => field !== undefined && field != "")
              .join(", "),
          }));
          createPopup(order, subTotal, ordertotal, vatAmount, vatTotalAmount);
        })
        .catch((err) => {
          this.setState({ loading: false });
        });
    }
  };

  const str_replace = (product_name) => {
    if (product_name !== "") {
      product_name = product_name.replaceAll("amp;", "&");
      product_name = product_name.replaceAll("apos;'", "'' ");
      product_name = product_name.replaceAll("quot;'", "'' ");
      return product_name;
    } else {
      return product_name;
    }
  };

  const createPopup = (
    order,
    subTotal,
    ordertotal,
    vatAmount,
    vatTotalAmount,
  ) => {
    // Sort order items to move those with UnitPrice 0 to the end
    const sortedItems = [...order.items].sort((a, b) => {
      if (a.UnitPrice === 0 && b.UnitPrice !== 0) return 1;
      if (a.UnitPrice !== 0 && b.UnitPrice === 0) return -1;
      return 0;
    });

    let headMoreTxt = (
      <>
        <div className="order-top">
          <div className="bottom order-flex">
            {/* Changed by K2b sangeetha for getting account details of particular order  */}
            <div className="order_no_details">
              <h3>
                {t("order_no_txt")} - {order.OrderNumber}
              </h3>
              <p>
                {t("order_placed_on_txt")}:{" "}
                <span className="date">
                  {" "}
                  {moment(order.createdAt).format("DD/MM/YYYY hh:mm A")}
                </span>{" "}
              </p>
              <p>
                {t("order_deleivery_on_txt")}:{" "}
                <span className="date"> {order.DateRequired} </span>
              </p>
              {order.PaymentMethod === "A" && (
                <p>
                  {t("payment_method_txt")}:{" "}
                  <span className="pay">
                    {" "}
                    {order.OrderPaid === "YES"
                      ? t("paid_pay_later_txt")
                      : t("pay_later_txt")}
                  </span>
                </p>
              )}
              {order.PaymentMethod === "K" && (
                <p>
                  {t("payment_method_txt")}:{" "}
                  <span className="pay">{t("online_payment_txt")}</span>
                </p>
              )}
              <p>
                {t("status_txt")}:
                <span className="pay"> {order.OrderStatus}</span>
              </p>
            </div>
            <div className="order_account_details">
              <p>
                {t("name_txt")}:{" "}
                <span className="date">{order.accountName}</span>{" "}
              </p>
              <p>
                {t("account_code_txt")}:{" "}
                <span className="date">{order.accountCode}</span>{" "}
              </p>
              <p>
                {t("email_address_txt")}:{" "}
                <span className="pay"> {order.accountEmail}</span>
              </p>
              <p>
                {t("address_txt")}:{" "}
                <span className="pay">{order.accountAddress}</span>
              </p>
              {order.PODetails && (
                <p>
                  {t("po_details_txt")}:{" "}
                  <span className="pay">{order.PODetails}</span>
                </p>
              )}
            </div>
            {/* Changed by K2b sangeetha for getting account details of particular order  */}
          </div>
        </div>
      </>
    );
    let closebtn = (
      <>
        <div className="pop-header-top order-top">
          <div className="head">
            <h4>
              {t("order_details_txt")} - {order.OrderNumber}{" "}
            </h4>
          </div>
          <span onClick={(e) => closeOrderDetail()} className="close"></span>
        </div>
      </>
    );
    let bodyMoreTxt = (
      <>
        <div className="modal-table">
          <h4 className="item-title">{t("ordered_items_txt")}</h4>
          <div className="checkout-table">
            <div className="table_overflow">
              <table>
                <thead>
                  <tr>
                    <td>{t("product_txt")}</td>
                    <td>{t("unit_of_sale_txt")}</td>
                    <td>{t("quantity_txt")}</td>
                    <td align="center">{t("price_txt")}</td>
                    <td align="right">{t("total_txt")}</td>
                  </tr>
                </thead>
                <tbody>
                  {/* Added Special offer and product number like frontend */}
                  {sortedItems.map((item, index) => {
                    return (
                      item.QuantityOrdered > 0 && (
                        <tr
                          key={index}
                          className={item.UnitPrice === 0 ? "free-prod-bg" : ""}
                        >
                          <td
                            data-title={t("product_txt")}
                            className="data-product-hide"
                          >
                            {str_replace(item.Description)} (
                            {item.ProductNumber.includes("_")
                              ? item.ProductNumber.substring(
                                  0,
                                  item.ProductNumber.indexOf("_"),
                                )
                              : item.ProductNumber}
                            )
                            {item.TaxCode !== "" && item.TaxCode === "T1" && (
                              <span className="color-red">*</span>
                            )}
                            {item.OfferFlag == "true" && (
                              <span className="offer-tag-wrap">
                                <span className="offer-tag">
                                  <img
                                    src={discountIcon}
                                    alt={t("offer_txt")}
                                    className="tag-icon"
                                  />
                                  {t("special_offer_txt")}
                                </span>
                              </span>
                            )}
                          </td>
                          <td data-title={t("unit_of_sale_txt")}>
                            {item.PricingUnit}
                          </td>
                          <td data-title={t("quantity_txt")}>
                            {item.QuantityOrdered}
                          </td>
                          <td data-title={t("price_txt")} align="center">
                            {priceFormat(parseFloat(item.UnitPrice))}
                          </td>
                          <td data-title={t("total_txt")} align="right">
                            {priceFormat(parseFloat(item.LinePrice))}
                          </td>
                        </tr>
                      )
                    );
                  })}
                  {/* Added Special offer and product number like frontend */}
                </tbody>
                <thead className="ord-grand-total">
                  {order.OrderNote !== "" && order.OrderNote !== null && (
                    <tr>
                      <td align="left" width={120} colSpan="7">
                        {t("order_notes_txt")}:{" "}
                        <span className="order_remarks">
                          {" "}
                          {getOrderNotes(order.OrderNote)}
                        </span>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td align="right" width={120} colSpan="4">
                      {t("subtotal_txt")}:
                    </td>
                    <td align="right">{priceFormat(subTotal)}</td>
                  </tr>
                  {vatAmount > 0 && (
                    <tr>
                      <td
                        align="right"
                        width={120}
                        colSpan="4"
                        className="td-vat-fee"
                      >
                        <span className="strong">
                          {t("vat_txt")}{" "}
                          <span className="vat-txt">
                            (20% of{" "}
                            <span className="vat-amt">
                              {priceFormat(vatTotalAmount)}
                            </span>
                            )<span className="color-red">*</span>:
                          </span>
                        </span>
                      </td>
                      <td className="cart-prod-vat" align="right">
                        {priceFormat(vatAmount)}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td align="right" width={120} colSpan="4">
                      {t("shipping_txt")}:
                    </td>
                    <td align="right">
                      <span className="color-red">{t("free_txt")}</span>
                    </td>
                  </tr>
                  <tr>
                    <td align="right" width={120} colSpan="4">
                      {t("grand_total_txt")}:
                    </td>
                    <td align="right">{priceFormat(ordertotal)}</td>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </div>
      </>
    );
    setOrderDetailPopup({
      headMoreTxt: headMoreTxt,
      closeButton: closebtn,
      bodyMoreTxt: bodyMoreTxt,
    });
  };

  const changeFilterHandler = (e) => {
    setFilter(e.target.value);
    setFilterText(e.target.options[e.target.selectedIndex].text);
    if (e.target.value === "custom") {
      setShowDatePicker(true);
    } else {
      setShowDatePicker(false);
      setFromDate(null);
      setToDate(null);
      setFilter(e.target.value);
    }
  };

  const changePeriodHandler = (e) => {
    const newPeriod = e.target.value;
    setPeriod(newPeriod); // update selected fiscal year in state
    //split fiscal year
    const [newStartYear, newEndYear] = newPeriod.split("-").map(Number);
    const fiscalStartMonthIndex = 8; // 0-based index for September
    const today = new Date();
    const currentFiscalYear = getCurrentFiscalYear();
    //compare sleted year with currentfiscalyear
    const isCurrentFiscalYear = newPeriod === currentFiscalYear;
    // MONTHLY filter logic
    if (filter === "monthly") {
      let visibleMonthNames = MonthNames;
      if (isCurrentFiscalYear) {
        // Calculate current fiscal month index
        const currentMonthIndex = today.getMonth(); // 0-based
        const monthsPassedSinceFiscalStart =
          (currentMonthIndex - fiscalStartMonthIndex + 12) % 12;
        const maxVisibleIndex = monthsPassedSinceFiscalStart;
        visibleMonthNames = MonthNames.slice(0, maxVisibleIndex + 1);
      }
      const selectedMonthIndex = MonthNames.indexOf(months);
      const isValidMonth =
        selectedMonthIndex >= 0 &&
        selectedMonthIndex < visibleMonthNames.length;
      if (!isValidMonth) {
        const defaultMonthNumber = ((0 + fiscalStartMonthIndex) % 12) + 1;
        setMonths(String(defaultMonthNumber));
      }
    }
    // QUARTERLY filter logic
    if (filter === "quarterly") {
      const currentQuarter = getCurrentFiscalQuarter();
      let maxQuarter = 4;
      if (isCurrentFiscalYear) {
        maxQuarter = currentQuarter;
      }
      if (parseInt(quarter) > maxQuarter) {
        setQuarter(maxQuarter > 0 ? String(maxQuarter) : "1");
      }
    }
  };

  const changeMonthHandler = (e) => {
    setMonths(e.target.value);
  };

  const changeOfferRangeHandler = (e) => {
    setOfferRange(e.target.value.trim());
  };

  useEffect(() => {
    let filteredOrders = temporders;
    // Apply search filter if searchInput is not empty
    if (searchInput !== "") {
      const lowercasedValue = searchInput.toLowerCase();
      filteredOrders = filteredOrders.filter((item) =>
        item.accountCode.toLowerCase().includes(lowercasedValue),
      );
    }
    // Apply offer range filter if offerRange is set
    if (offerRange !== "") {
      filteredOrders = filteredOrders.filter((item) => {
        const offerConvertFrom =
          analysisType === "sector"
            ? parseFloat(item.OrderTotalWithVat)
            : parseFloat(item.offerConvertFrom);
        if (offerRange === "250") {
          return offerConvertFrom < 250;
        } else if (offerRange === "250-500") {
          return offerConvertFrom >= 250 && offerConvertFrom <= 500;
        } else if (offerRange === "500-750") {
          return offerConvertFrom > 500 && offerConvertFrom <= 750;
        } else if (offerRange === "750-1000") {
          return offerConvertFrom > 750 && offerConvertFrom <= 1000;
        } else if (offerRange === "1000") {
          return offerConvertFrom > 1000;
        }
        return true;
      });
    }
    setPromoOrders(filteredOrders);
  }, [searchInput, temporders, offerRange, analysisType]);

  const formatDate = (dateString) => {
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  };

  const DateChange = (value, type) => {
    if (type === "from") {
      setFromDate(value);
      if (toDate && value && value > toDate) {
        setToDate(null);
      }
    } else if (type === "to") {
      if (!fromDate || value >= fromDate) {
        setToDate(value);
      } else {
        // Handle invalid date selection
        setToDate(null);
      }
    }
  };

  // Calculate dynamic pagination options
  const calculatePaginationOptions = (totalRecords, interval) => {
    const options = [];
    for (let i = interval; i <= totalRecords; i += interval) {
      options.push(i);
    }
    return options;
  };

  const totalRecords = promoOrders.length; // Get the total records count
  const paginationOptions = calculatePaginationOptions(totalRecords, 10); // Generate options with interval of 10
  const options = [];
  for (let i = currentyear; i >= 2023; i--) {
    if (i === currentyear && currentMonth < 9) {
      continue;
    }
    const year = i;
    options.push(
      <option value={year + "-" + (year + 1)}>
        {year + "-" + (year + 1)}
      </option>,
    );
  }

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);
  };

  const currentFiscalYear = getCurrentFiscalYear();
  let visibleMonthNames = MonthNames;
  if (period === currentFiscalYear) {
    // Limit to current fiscal month
    const fiscalIndex = (new Date().getMonth() - 8 + 12) % 12; // Sep=0, Oct=1, ... Aug=11
    visibleMonthNames = MonthNames.slice(0, fiscalIndex + 1);
  }

  let loadingbuffer = isLoading ? "loading-buffer" : "";

  return (
    <div
      className={`chart-container chart-promo-offers ${loadingbuffer}`}
      style={{ verticalAlign: "top" }}
    >
      <div className="chart-Hdr">
        <div className="chart-Hdr-txt chart-fltr">
          <select
            value={analysisType}
            onChange={(e) => setAnalysisType(e.target.value)}
          >
            <option value={"cart"}>{t("streetfood_sauces_promo_txt")}</option>
            <option value={"sector"}>{t("pinsa_promo_txt")}</option>
          </select>
          <div
            className="chart-fltr"
            style={{ height: "32px", width: "190px" }}
          >
            <input
              type="text"
              value={searchInput}
              onChange={handleChange}
              placeholder={t("search_by_account_code_txt")}
            />
          </div>
        </div>
        {/* New Sort Filter Dropdown */}
        <div className="chart-fltr-Hldr">
          {analysisType === "sector" && (
            <>
              <div className="chart-fltr">
                {
                  <select
                    name="mainDepot"
                    value={mainDepot}
                    onChange={(e) => changeMainDepotHandler(e)}
                  >
                    <option value="">{t("select_main_depot_txt")}</option>
                    {mainDepotList.map((item) => (
                      <option key={item.mainDepot} value={item.mainDepot}>
                        {item.mainDepot}
                      </option>
                    ))}
                  </select>
                }
              </div>
              <div className="chart-fltr">
                {
                  <select
                    name="subDepot"
                    value={subDepot}
                    onChange={(e) => changeSubDepotHandler(e)}
                  >
                    <option value="">{t("select_local_depot_txt")}</option>
                    {subDepotList.map((item) => (
                      <option key={item.subDepot} value={item.subDepot}>
                        {item.subDepot}
                      </option>
                    ))}
                  </select>
                }
              </div>
              <div className="chart-fltr">
                <select
                  value={sector}
                  onChange={(e) => setSector(e.target.value)}
                >
                  <option value="All">{t("all_txt")}</option>
                  {sectorList.map((item) => (
                    <option key={item._id} value={item.MasterValue}>
                      {item.MasterValue}
                    </option>
                  ))}
                </select>
              </div>
            </>
          )}
          <div className="chart-fltr">
            {
              <select
                value={offerRange}
                onChange={(e) => changeOfferRangeHandler(e)}
              >
                <option value={"all"}>{t("all_amount_txt")}</option>
                <option value={"250"}>{t("below_250_txt")}</option>
                <option value={"250-500"}>{t("251_to_500_txt")}</option>
                <option value={"500-750"}>{t("501_to_750_txt")}</option>
                <option value={"750-1000"}>{t("751_to_1000_txt")}</option>
                <option value={"1000"}>{t("above_1000_txt")}</option>
              </select>
            }
          </div>
          <div className="chart-fltr">
            <select
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
            >
              <option value="order">{t("ordered_date_txt")}</option>
              <option value="delivery">{t("delivery_date_txt")}</option>
            </select>
          </div>
          <div
            className="chart-fltr"
            onMouseEnter={() => {
              if (filter === "custom" && !showDatePicker) {
                setShowDatePicker(true);
              }
            }}
            onMouseLeave={() => {
              if (filter === "custom" && showDatePicker) {
                setShowDatePicker(false);
              }
            }}
          >
            {
              <select value={filter} onChange={(e) => changeFilterHandler(e)}>
                <option value={0}>{t("all_txt")}</option>
                <option value={"weekly"}>{t("current_week_txt")}</option>
                <option value={"monthly"}>{t("monthly_txt")}</option>
                <option value={"quarterly"}>{t("quarterly_txt")}</option>
                <option value={"FYdata"}>{t("fy_data_txt")}</option>
                <option value={30}>{t("past_30_days_txt")}</option>
                <option value={90}>{t("past_90_days_txt")}</option>
                <option value={180}>{t("past_180_days_txt")}</option>
                <option value={365}>{t("past_1_year_txt")}</option>
                <option value={"custom"}>{t("custom_date_txt")}</option>
              </select>
            }
            {showDatePicker && (
              <div className="date-picker-container">
                <label>{t("from_label_txt")}</label>
                <DatePicker
                  selected={fromDate}
                  onChange={(date) => DateChange(date, "from")}
                  showDisabledMonthNavigation
                  dateFormat="dd/MM/yyyy"
                  maxDate={
                    filterType === "delivery"
                      ? new Date(
                          new Date().getTime() + 30 * 24 * 60 * 60 * 1000,
                        )
                      : new Date()
                  }
                  placeholderText={t("select_date_txt")}
                />
                <label>{t("to_label_txt")}</label>
                <DatePicker
                  selected={toDate}
                  showDisabledMonthNavigation
                  dateFormat="dd/MM/yyyy"
                  onChange={(date) => DateChange(date, "to")}
                  maxDate={
                    filterType === "delivery"
                      ? new Date(
                          new Date().getTime() + 30 * 24 * 60 * 60 * 1000,
                        )
                      : new Date()
                  }
                  placeholderText={t("select_date_txt")}
                />
              </div>
            )}
            {filter === "quarterly" && (
              <select
                value={quarter}
                onChange={(e) => setQuarter(Number(e.target.value))}
              >
                {getAvailableQuarters(period)}
              </select>
            )}
            {filter === "monthly" && (
              <select value={months} onChange={(e) => changeMonthHandler(e)}>
                {visibleMonthNames.map((monthName, index) => {
                  const monthNumber = ((index + 8) % 12) + 1; // fiscal-to-calendar month number
                  return (
                    <option key={monthNumber} value={monthNumber}>
                      {monthName}
                    </option>
                  );
                })}
              </select>
            )}
            {(filter === "monthly" ||
              filter === "quarterly" ||
              filter === "FYdata") && (
              <select value={period} onChange={(e) => changePeriodHandler(e)}>
                {options}
              </select>
            )}
          </div>
        </div>
        <div className="fltr-sub-val">
          {promoOrders.length > 0 && (
            <span className="fltr-val" style={{ display: "inline" }}>
              {t("total_records_txt")}: <strong>{promoOrders.length}</strong>{" "}
              {[
                t("current_week_txt"),
                t("monthly_txt"),
                t("quarterly_txt"),
                t("fy_data_txt"),
              ].includes(filtertext)
                ? ""
                : filtertext != "" && filtertext != t("custom_date_txt")
                  ? " (" + filtertext + ")"
                  : filtertext === t("custom_date_txt") && fromDate && toDate
                    ? " (" +
                      formatDate(fromDate) +
                      " - " +
                      formatDate(toDate) +
                      ")"
                    : " (" + t("all_txt") + ")"}
            </span>
          )}
          {analysisType === "cart" && totalBeforeSpend > 0 && (
            <>
              <span style={{ paddingLeft: "6px" }}> | </span>
              <span
                className="fltr-val"
                style={{ display: "inline", paddingLeft: "6px" }}
              >
                {" "}
                {t("total_spend_before_promo_txt")}:{" "}
                <strong>{priceFormat(totalBeforeSpend)}</strong>
              </span>
            </>
          )}
          {totalAfterSpend > 0 && (
            <>
              <span style={{ paddingLeft: "6px" }}> | </span>{" "}
              <span
                className="fltr-val"
                style={{ display: "inline", paddingLeft: "6px" }}
              >
                {" "}
                {analysisType === "cart"
                  ? t("total_spend_after_promo_txt")
                  : t("total_order_amount_txt")}{" "}
                <strong>{priceFormat(totalAfterSpend)}</strong>
              </span>
            </>
          )}
          {analysisType === "cart" && totalDifference > 0 && (
            <>
              <span style={{ paddingLeft: "6px" }}> | </span>{" "}
              <span
                className="fltr-val"
                style={{ display: "inline", paddingLeft: "6px" }}
              >
                {" "}
                {t("total_difference_in_spend_txt")}:{" "}
                <strong>{priceFormat(totalDifference)}</strong>
              </span>
            </>
          )}
        </div>
      </div>
      <DataTable
        className={analysisType === "sector" ? "sector-based-table" : ""}
        columns={columns}
        data={promoOrders}
        customStyles={customStyles}
        noDataComponent={
          <div className="no-records-found">
            {t("no_data_filtered_search_txt")}
          </div>
        }
        pagination
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 20, 40, 60, 80, 100]}
        paginationComponentOptions={paginationComponentOptions}
      />
      {showOrderDetail === true && (
        <Popup
          extClass="order-pop my-order-details-pop"
          headmoreText
          headMoreTxt={orderDetailPopup?.headMoreTxt}
          closebtn={orderDetailPopup?.closeButton}
          bodyMoreTxt={orderDetailPopup?.bodyMoreTxt}
        />
      )}
    </div>
  );
};
